import './externals/calcom.styles';
import {
    hydrate,
    hydrateAll,
    hydrateAllObserverWidgets,
    hydrateObserverWidget,
    initiateWidget,
    renderObserver,
    shouldHydrateOnRuntime,
} from './api';

(window as any).SSRRuntime = {
    RuntimeReactHelpers: {
        hydrate,
        hydrateObserverWidget,
        hydrateAll,
        hydrateAllObserverWidgets,
        renderObserver,
        shouldHydrateOnRuntime,
        initiateWidget,
    },
};

interface Window {
    getDeferred?: (name: string) => void | { resolve: () => void };
}

if (typeof window !== 'undefined') {
    (window as Window)?.getDeferred?.('ssrLibrariesLoaded')?.resolve();
}
